<template>
  <StudioMultiSelect
    v-model="tagsSelected"
    :searchable="true"
    :items="selectItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ tagsSelected.length }} {{ filterMessage(tagsSelected) }}
      </span>
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import filtersModel from '@/mixins/filters-model';
import { mapGetters } from 'vuex';

export default {
  name: 'TagView',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    filtersModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    selectItems: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    label() {
      return this.$t('components.filters.TagView.label');
    },
    placeholder() {
      return this.$t('components.filters.TagView.placeholder');
    },
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter', 'activeDashboard']),
    tagsSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }
        return [];
      },
      set(newValue) {
        let newTags = newValue;
        const shouldNotifyNoTagsSelected = !newValue || newValue.length === 0;
        const shouldTransformToTagValues = newValue && newValue.length && typeof (newValue[0]) === 'object';

        if (shouldNotifyNoTagsSelected) {
          return this.$emit('input', undefined);
        }
        if (shouldTransformToTagValues) {
          newTags = newValue.map(v => v && v.value);
        }
        this.$emit('input', {
          value: newTags,
        });
      },
    },
  },
  watch: {
    'card.tagsView': {
      handler(newValue) {
        if (newValue) {
          this.tagsSelected = newValue;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
